import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './AuthService';
import { jwtDecode } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    clientId: any = sessionStorage.getItem('clientId') ? JSON.parse(sessionStorage.getItem('clientId')) : null;
    userType: any = null;
    private signInRedirectInProgress = false;

    constructor(private authService: AuthService, private router: Router,) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            // Make sure userManager is initialized properly in authService.
            const token = await this.authService.getAccessToken();
            if (token) {
                const decodedToken: any = jwtDecode(token);
                const userRoles = decodedToken?.roles || [];
                this.authService.setRoles(decodedToken?.roles || []);
                this.authService.setUserType(decodedToken?.userType)
                const allowedRoles = route.data['roles'] as string[];

                if (allowedRoles && !userRoles.some(role => allowedRoles.includes(role))) {
                    this.router.navigate(['/home']);
                    return false;
                }
                this.userType = this.authService.getUserType();

                // Dynamically set clientId based on userType
                if (this.userType === 'EXTERNAL') {
                    // this.authService.clientId = decodedToken?.client_id;
                    const id = decodedToken?.client_id;
                        if (id != null) {
                        this.authService.setClientId(id);
                        }
                    sessionStorage.setItem('clientId', JSON.stringify(Number(decodedToken.client_id)));
                }
                return true;
            } else {
                // If token is not found, redirect to sign in
                if (this.authService.userManager) {
                   await this.redirectToLogin();
                } else {
                    console.error('User Manager is not initialized.');
                    this.router.navigate(['/']);
                }
                return false;
            }
        } catch (error) {
            console.error('Error verifying access:', error);
            // Handle the case where the UserManager is not defined.
            if (this.authService.userManager) {
                await this.redirectToLogin();
            } else {
                console.error('User Manager is not initialized.');
                this.router.navigate(['/']);
            }
            return false;
        }
    }

    private async redirectToLogin():
  Promise<void> {

  if (this.signInRedirectInProgress) {
    return;
  }

  this.signInRedirectInProgress = true;

  try {
    await this.authService.login();
  } catch (error) {
    this.signInRedirectInProgress = false;

    console.error(
      'Unable to redirect to login:',
      error
    );
  }
}

    /*async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            const isAuthenticated = await this.authService.isLoggedIn();

            if (!isAuthenticated) {
                console.warn('User authentication or profile loading failed.');
                await this.authService.userManager?.signinRedirect(); // Redirect to login page
                return false;
            }

            const token = await this.authService.getAccessToken();
            if (!token) {
                await this.authService.userManager?.signinRedirect();
                return false;
            }

            const decodedToken: any = jwtDecode(token);
            const userRoles = decodedToken?.roles || [];
            this.authService.setRoles(userRoles);
            this.authService.setUserType(decodedToken?.userType);

            const allowedRoles = route.data['roles'] as string[];
            if (allowedRoles && !userRoles.some(role => allowedRoles.includes(role))) {
                this.router.navigate(['/home']);
                return false;
            }

            this.userType = this.authService.getUserType();
            if (this.userType === 'EXTERNAL') {
                this.authService.clientId = decodedToken?.client_id;
                sessionStorage.setItem('clientId', JSON.stringify(Number(decodedToken.client_id)));
            }

            return true;
        } catch (error) {
            console.error('Error verifying access:', error);
            await this.authService.userManager?.signinRedirect();
            return false;
        }
    }*/

}



/*import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './AuthService';
import {jwtDecode} from 'jwt-decode'
import {UserManager} from 'oidc-client';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    private userManager: UserManager;
    clientId: any = localStorage.getItem('internalClientId') ? JSON.parse(localStorage.getItem('internalClientId')) : null; // this var is used lny for external clientId
    userType: any = null;
    userRoles:any;
    constructor(private authService: AuthService, private router: Router) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            const token = await this.authService.getAccessToken();
            if (token) {
                const decodedToken: any = jwtDecode(token);
                const userRoles = decodedToken?.roles || [];
                this.userRoles = decodedToken?.roles || []
                this.authService.setRoles(decodedToken?.roles || [])
                const allowedRoles = route.data['roles'] as string[];

                if (allowedRoles && !userRoles.some(role => allowedRoles.includes(role))) {
                    this.router.navigate(['/home']);
                    return false;
                }
                this.userType = decodedToken.userType;// Extract clientId from JWT
                // Now you can use this.clientId wherever needed, e.g., in API calls
                if(this.userType === 'EXTERNAL'){
                    this.clientId = decodedToken.client_id;
                }else if(this.userType === 'INTERNAL'){
                    this.clientId = JSON.parse(localStorage.getItem('internalClientId'))
                }
                return true;
            } else {
                // No token found, redirect to signin page
                await this.userManager.signinRedirect();
                return false;
            }
        } catch (error) {
            console.error('Error verifying access:', error);
            // Redirect to signin in case of an error
            await this.userManager.signinRedirect();
            return false;
        }
    }
}*/
